import { FacebookIcon, FacebookShareButton, WhatsappIcon, WhatsappShareButton } from "react-share";

export const ShareModalContent = () => {
  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    alert("Link copied to clipboard!");
  };

  return (
    <div className="text-center p-10">
      <input
        type="text"
        value={window.location.href}
        readOnly
        className="border border-neutral-300 dark:border-neutral-700 rounded-lg p-2 w-full text-center"
      />
      <div className="flex justify-center mt-4">
        <button
          className="bg-orange-600 hover:opacity-90 text-white rounded-lg px-4 py-2 mr-2"
          onClick={handleCopyLink}
        >
          Copy Link
        </button>
        <FacebookShareButton url={window.location.href}>
          <button className="rounded-lg px-4 py-2 ml-2 flex items-center justify-between gap-2 border border-neutral-200 dark:border-neutral-700 hover:bg-blue-200 dark:hover:text-blue-600 transition duration-200">
            <FacebookIcon size={32} round={true}/> <span className={"hidden md:block"}>Share on Facebook</span>
          </button>
        </FacebookShareButton>
        <WhatsappShareButton url={window.location.href}>
          <button className="rounded-lg px-4 py-2 ml-2 flex items-center justify-between gap-2 border border-neutral-200 dark:border-neutral-700 hover:bg-green-200 dark:hover:text-green-600 transition duration-200">
            <WhatsappIcon size={32} round={true}/> <span className={"hidden md:block"}>Share on WhatsApp</span>
          </button>
        </WhatsappShareButton>
      </div>
    </div>
  );
};
